import styled from 'styled-components';
import { Box } from '@rsos/components/capstone/base';
import InputText from '@rsos/components/capstone/base/form/inputs/InputText';

export const IconWrapper = styled(Box).attrs(() => ({
  height: '100%',
  width: 50,
  justify: 'center',
  align: 'center',
  color: 'secondaryLink',
}))`
  position: absolute;
  opacity: ${({ searchTerm }) => (searchTerm ? 1 : 0.25)};
  z-index: 2;
`;

export const Input = styled(InputText).attrs({})`
  font-size: 16px;
  padding-left: 45px;
  padding-right: 45px;
`;
